import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { store } from "./app/store";
// import { persistor, store } from "./app/store";
import "./index.css";
import { App } from "./app/App";
import ReactGA from "react-ga4";
import reportWebVitals from "./reportWebVitals";
import { getCookieStateAnalytics } from "./features/app/appSlice";
// import { PersistGate } from 'redux-persist/integration/react';

ReactGA.initialize("G-DWMGJ9JWXV");

const SendAnalytics = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

const RootComponent = () => {
  const analytics = useSelector(getCookieStateAnalytics);
  useEffect(() => {
    if (analytics) {
      reportWebVitals(SendAnalytics);
    }
  }, [analytics]);

  return <App />;
};

const rootElement = document.getElementById("root") as HTMLElement;

const app = (
  <React.StrictMode>
    <Provider store={store}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
      <RootComponent />
      {/* </PersistGate> */}
    </Provider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}
